<template>
  <!-- ali新增登出功能 -->
  <es-over-layout
    custom-class="{{ customClass }}"
    useDefaultNavbar="{{false}}"
    layout="{{['header']}}"
    navbarTitle=""
    esMainStyle="{{{background: 'transparent'}}}"
    navbarUseRight
    useRight="{{true}}"
    leftArrow="{{true}}"
    needScroll="{{!isMiniH5}}"
    bind:onscroll="handleScroll"
  >
    <view class="home-header" wx:style="{{ headerStyle }}" wx:if="{{!isMiniH5}}">
      <es-navbar left-arrow="{{false}}" bind:click-left="goBack" onClickLeft="{{homeBack}}">
        <view slot="left" wx:style="display: flex;">
          <es-icon size="25" wx:style="display: inline;" name="angle-left" />
        </view>
      </es-navbar>
    </view>
    <view class="home-body">
      <Bg wx:class="{{bannerClass}}" currentProd="{{currentProd}}"/>
      <Tabs class="content" bindtabClick="onTabClick" tabsData="{{homeTabs}}"/>
      <!-- 12306登录提示条 -->
      <!-- 改为不提示 -->
      <!-- <ToLoginTip wx:if="{{currentProd === 'train'}}" class="to-login-tip" /> -->
    </view>
  </es-over-layout>
  <es-toast id="es-toast" />
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import initMixin from '@/mixins'
  import pageHideForShare from '@/mixins/pageHideForShare'
  import { isDdPassengerH5, isWXMini, isALIMini } from '@/common/constant'
  import { trackEvent } from '@/common/track'
  import { closePage } from '@/common/jump'
  import { goTo, query as webxQuery, hashQuery, alimpReady, xenv } from '@didi/webx-js'
  import { getStorage, setStorage } from '@/utils/storage'
  import { HOME_TAB_SELECT } from '@/utils/train-storage'
  import { is } from '@didi/spring-base'
  import { setShareConfig } from '@/utils/share'
  const query = () => {
    return {
      ...webxQuery(),
      ...hashQuery(),
    }
  }

  createPage({
    mixins: [initMixin, pageHideForShare],
    data: {
      scrollTop: 0,
      currentProd: ''
    },
    computed: {
      ...store.mapGetters({
        isAliAndNotLogin: 'user.isAliAndNotLogin'
      }),
      flightsTabVisible() {
        const { appid } = this.$mpxRoute.query || {}
        const { hide_flights } = query()
        return hide_flights !== '1' || ['121735', '2021004166617541'].includes(appid) // 在机火支付宝小程序里面不展示租车tab
      },
      carRentalTabVisible() {
        const { appid } = this.$mpxRoute.query || {}
        return !['121735', '2021004166617541'].includes(appid)// 在机火支付宝小程序里面不展示租车tab
      },
      homeTabs() {
        const defaultTabs = [{
          name: '火车票',
          key: 'train',
          comp: 'train-home-comp',
          default: this.currentProd === 'train'
        }]
        this.flightsTabVisible && defaultTabs.push({
          name: '机票',
          key: 'flights',
          comp: 'flights-home-comp',
          default: this.currentProd === 'flights'
        })
        this.carRentalTabVisible && defaultTabs.push({
          name: '租车',
          key: 'carRental'
        })
        return defaultTabs
      },
      headerStyle() {
        return {
          transition: 'all .3s',
          backgroundColor: this.scrollTop > 20 ? '#fff' : 'transparent',
        }
      },
      bannerClass() {
        return {
          'banner-swiper': true,
          'mini': this.isMiniH5
        }
      },
      customClass(){
        const bgClass = isDdPassengerH5 ? '': 'home-bg-mini'
        return `home-container ${bgClass}`
      },
      isMiniH5(){
        return isWXMini || isALIMini
      },
      homeShareConfig() {
        return {
          share_title: '滴滴火车票',
          path: `/pages/index/index?dchn=dv39rv6`,
          img_url:
            'https://ut-static.udache.com/webx/sfc/pcRSkRARyx8SBXGBKSD3R_clipboard_image_1718784145429.png',
          card_content: '滴滴火车票',
          timeline_share_link: `https://v.didi.cn/p/dv39rv6`
        }
      },
    },
    methods: {
      ...store.mapActions({
        initHomeApollo: 'common.initHomeApollo',
        setBannerData: 'coupon.setBannerData',
      }),
      async goBack() {
        trackEvent('userteam_train_home_return_ck', 'UT-火车票-首页-返回-点击')
      },
      onTabClick({ detail }) {
        const { tab } = detail
        switch(tab.key) {
          case 'carRental':
            this.toCarRental()
            break
          case 'flights':
            this.tabsTrack('click', 'flights')
          default:
            this.currentProd = tab.key
            setStorage({
              key: HOME_TAB_SELECT,
              data: tab.key
            })
            break
        }
      },
      toCarRental() {
        const { pre_prod_key } = query()
        if(pre_prod_key === 'ut-car-rental') {
          this.homeBack()
          return
        }
        this.tabsTrack('click')
        const dchn = isDdPassengerH5
          ? 'Opjeolv'
          : isWXMini
            ? '3MWPpo5'
            : isALIMini
              ? 'Yv7vDgx'
              : ''
        dchn && goTo({ url: `https://v.didi.cn/${dchn}?pre_prod_key=ut-train` })
      },
      homeBack() {
        closePage()
      },
      tabsTrack(type, prod = 'carRental') {
        const tabTrackMap = prod === 'carRental'
          ? {
              'click': {
                key: 'userteam_train_home_cartab_ck',
                name: 'UT-火车票-首页-顶部租车tab-点击',
              },
              'show': {
                key: 'userteam_train_home_cartab_sw',
                name: 'UT-火车票-首页-顶部租车tab-展现',
              }
            }
          : {
              'click': {
                key: 'userteam_plane_home_cartab_ck',
                name: 'UT-飞机票-首页-顶部飞机票tab-点击',
              },
              'show': {
                key: 'userteam_plane_home_cartab_sw',
                name: 'UT-飞机票-首页-顶部飞机票tab-展现',
              }
            }
        trackEvent(tabTrackMap[type].key, tabTrackMap[type].name)
      },
      handleScroll({ detail }) {
        this.scrollTop = detail
      },
    },
    created() {
      this.initHomeApollo()
      const defaultTabProd = query().home_tab || (getStorage(HOME_TAB_SELECT) || 'train')
      this.currentProd = this.flightsTabVisible 
        ? defaultTabProd 
        : 'train'
    },
    mounted() {
      mpx.removeStorage({ key: 'backPageUrl' }) // 清除本地存储URL缓存
      mpx.setNavigationBarColor({ frontColor: '#000000' })
    },
    onShow() {
      this.tabsTrack('show')
      setShareConfig(this.homeShareConfig)
      this.flightsTabVisible && this.tabsTrack('show', 'flights')
    },
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .home-header
    position fixed
    top 0
    left 0
    z-index 3
  .banner-swiper
    height 240px
    width 100%
    &.mini
      margin-top -40px
  .home-container
    background #f2f6f9
  .home-bg-mini
    background-position-y -40px
  .header
    height 1px
    padding 0 24px
  .content
    margin -78px 0 16px
    position relative
  .to-login-tip
    position fixed
    bottom 48px
    left 0
</style>

<script  name="json">
  module.exports = {
    usingComponents: {
      'es-over-layout': '@/es-mpx-ui/lib/layout',
      'es-toast': '@didi/es-mpx-ui/lib/toast',
      'ToLoginTip': '@/components/to-login-tip',
      'Bg': './components/banner-swiper',
      'Tabs': './components/tabs',
    }
  }
</script>

